define('views/modals/claim/goods-collection',[
    'jquery',
    'underscore',
    'mediator',

    'views/base/view',
    'views/base/collection',
    'lib/utils',

    'text!templates/modals/claim/goods-collection-item.ejs'
], function(
    $, _, mediator,

    View, CollectionView, utils,

    templateItem
) {
    'use strict';

    var ClaimGoodsItem = View.extend({
        template: templateItem,
        tagName: 'tr',
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            if (this.model.get('canEdit')) {
                this.delegate('click', '.btn-danger', this.onDeleteClick);
            }
        },
        onDeleteClick: function() {
            this.model.collection.remove(this.model);
        }
    });

    var ClaimGoodsCollectionView = CollectionView.extend({
        autoRender: true,
        tagName: 'tbody',
        region: 'claim-goods',
        itemView: ClaimGoodsItem
    });

    return ClaimGoodsCollectionView;
});

